import { EnumBillType, EnumBillTypeOption } from "./EnumBillType";

/**
 * 
 * @description 自动生成的代码,请勿修改
 */
export default class DtoRequestTemplate {
    constructor() {
        //无参构造函数
    }

    [proName: string]: any;
    /**
     * 
     */
    OrderId?: string;
    /**
     * 
     */
    PoolId?: string;
    /**
     * 
     */
    Type?: EnumBillType;
    /**
     * 
     */
    SelectPoolId?: string;
}

/**
 * -表单校验
 */
export const DtoRequestTemplateRules = {
}
